<template>
    <el-container>
        <fhead></fhead>
        <el-main>

            <el-row v-if="coinShow" class="center" :gutter="20">
                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <router-link to="accounts" tag="div" class="grid-content bg-purple">
                        <div class="tool_warp">
                            <div>{{$t('l.accountCount')}}</div>
                            <div class="txt">{{accountCount}}</div>
                        </div>
                    </router-link>
                </el-col>
                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <router-link to="asset" tag="div" class="grid-content bg-purple">
                        <div class="grid-content bg-purple">
                            <div class="tool_warp">
                                <div>{{$t('l.assetCount')}}</div>
                                <div class="txt">{{assetCount}}</div>
                            </div>
                        </div>
                    </router-link>
                </el-col>
                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <router-link to="currency" tag="div" class="grid-content bg-purple">
                        <div class="tool_warp">
                            <div>{{$t('l.currencyCount')}}</div>
                            <div class="txt">{{currencyCount}}</div>
                        </div>
                    </router-link>
                </el-col>
                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <router-link to="alias" tag="div" class="grid-content bg-purple">
                        <div class="tool_warp">
                            <div>{{$t('l.aliasCount')}}</div>
                            <div class="txt">{{aliasCount}}</div>
                        </div>
                    </router-link>
                </el-col>
            </el-row>
            <el-card class="box-card center">

                <div slot="header" class="clearfix">
                    <span>{{$t('l.block')}}</span>
                </div>
                <el-table v-loading="BlocksLoading" stripe :data="BlocksData" style="width: 100%">
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <el-table :data="scope.row.transactions" border style="width: 100%">
                                <el-table-column :label="$t('l.senderRS')" width="360">
                                    <template slot-scope="scope">
                                        <router-link :to="'/account/'+scope.row.senderRS">
                                            <el-button type="text">{{scope.row.senderRS}}</el-button>
                                        </router-link>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('l.recipientRS')" width="360">
                                    <template slot-scope="scope">
                                        <router-link :to="'/account/'+scope.row.recipientRS">
                                            <el-button type="text">{{scope.row.recipientRS}}</el-button>
                                        </router-link>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('l.amountNQT')" width="180">
                                    <template slot-scope="scope">{{$g.wallet.amount(scope.row.amountNQT)}}</template>
                                </el-table-column>
                                <el-table-column :label="$t('l.feeNQT')" width="180">
                                    <template slot-scope="scope">{{$g.wallet.amount(scope.row.feeNQT)}}</template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('l.height')" width="180">
                        <template slot-scope="scope">
                            <router-link :to="'block/'+scope.row.height">
                                <el-button type="text">{{scope.row.height}}</el-button>
                            </router-link>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('l.timestamp')" width="180">
                        <template
                                slot-scope="scope"
                        >{{$g.wallet.formatDateTime(scope.row.timestamp, ($store.state.epochBeginning - 500))}}
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('l.totalAmountNQT')" width="180">
                        <template slot-scope="scope">{{$g.wallet.amount(scope.row.totalAmountNQT)}}</template>
                    </el-table-column>
                    <el-table-column :label="$t('l.feeNQT')" width="120">
                        <template slot-scope="scope">{{$g.wallet.amount(scope.row.totalFeeNQT)}}</template>
                    </el-table-column>
                    <el-table-column
                            prop="transactions.length"
                            :label="$t('l.transactionsLength')"
                            width="80"
                    ></el-table-column>
                    <el-table-column :label="$t('l.generatorRS')" width="360">
                        <template slot-scope="scope">
                            <router-link :to="'/account/'+scope.row.generatorRS">
                                <el-button type="text">{{scope.row.generatorRS}}</el-button>
                            </router-link>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <el-card class="box-card center" style="margin-top: 60px">
                <div slot="header" class="clearfix">
                    <span>{{$t('l.generators')}}</span>
                    <span
                            style="color: #909399;"
                    >（{{$t('l.generators1')}}：{{nextBlock.activeCount}}，{{$t('l.generators2')}}）</span>
                </div>
                <el-table
                        v-loading="nextBlockLoading"
                        stripe
                        :data="nextBlock.generators"
                        style="width: 100%"
                >
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <el-table :data="scope.row.lessors" border style="width: 560px">
                                <el-table-column :label="$t('l.lessorRS')" width="360">
                                    <template slot-scope="scope">
                                        <router-link :to="'/account/'+scope.row.lessorRS">
                                            <el-button type="text">{{scope.row.lessorRS}}</el-button>
                                        </router-link>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('l.guaranteedBalanceNQT')">
                                    <template slot-scope="scope">{{$g.wallet.amount(scope.row.guaranteedBalanceNQT)}}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('l.accountRS')" width="360">
                        <template slot-scope="scope">
                            <router-link :to="'/account/'+scope.row.accountRS">
                                <el-button type="text">{{scope.row.accountRS}}</el-button>
                            </router-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="effectiveBalance" :label="$t('l.effectiveBalance')"
                                     width="180"></el-table-column>
                    <el-table-column prop="sum" :label="$t('l.lessorSum')" width="180"></el-table-column>
                    <el-table-column :label="$t('l.lessorTimes')" width="180">
                        <template
                                slot-scope="scope"
                        >{{$g.wallet.formatDateTime(scope.row.hitTime, ($store.state.epochBeginning - 500))}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="deadline" :label="$t('l.deadline')" width="180"></el-table-column>
                </el-table>
            </el-card>
        </el-main>
        <el-footer class="footer">
            COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
            <a
                    target="_blank"
                    href="https://hebeblock.com/"
            >HEBEBLOCK</a>
        </el-footer>
    </el-container>
</template>

<script>
    import fhead from "./fhead.vue";

    var deadline;
    var load;
    var loadline;
    export default {
        name: "HelloWorld",
        components: {
            fhead
        },
        data() {
            return {
                BlocksLoading: true,
                nextBlockLoading: true,
                BlocksData: [],
                nextBlock: {
                    generators: []
                },
                accountCount: 0,
                assetCount: 0,
                currencyCount: 0,
                aliasCount: 0,
                coinShow: false
            };
        },
        methods: {
            Transactions(item) {
                if (item.transactions.length != 0 && !item.transactions[0].amountNQT) {
                    this.$ajax({
                        method: "get",
                        url:
                            "requestType=getBlock&height=" +
                            item.height +
                            "&includeTransactions=true&includeExecutedPhased=true"
                    }).then(response => {
                        item.transactions = response.transactions;
                        item.transactions.forEach(v => {
                            v = this.$g.wallet.transactions(v, this.$store.state.apiText);
                        });
                    });
                }
            },
            Lessors(item) {
                this.$ajax({
                    method: "get",
                    url: "requestType=getAccountLessors&account=" + item.accountRS
                }).then(response => {
                    item.lessors = response.lessors;
                    item.lessors.forEach(v => {
                        v = this.$g.wallet.lessors(v, this.$store.state.apiText);
                    });
                    item.sum = response.lessors.length;
                });
            },
            Generators() {
                this.nextBlockLoading = true;

                this.$ajax({
                    method: "get",
                    url: "requestType=getNextBlockGenerators&limit=5"
                }).then(response => {
                    if (
                        this.nextBlock.generators.length != 0 &&
                        response.generators[0].hitTime == this.nextBlock.generators[0].hitTime
                    ) {
                    } else {
                        this.nextBlock = response;
                    }
                    this.nextBlockLoading = false;

                    this.nextBlock.generators.forEach(item => {
                        this.Lessors(item);
                        item = this.$g.wallet.effectiveBalance(
                            item,
                            this.$store.state.apiText
                        );
                        item.deadline = this.$g.wallet.timeDiff(
                            this.$g.wallet.formatDateTime(
                                item.hitTime,
                                this.$store.state.epochBeginning - 500
                            )
                        );
                    });
                    window.clearInterval(deadline);

                    deadline = setInterval(() => {
                        this.nextBlock.generators.forEach(item => {
                            --item.deadline;
                        });
                    }, 1000);
                });
            },
            Blocks() {
                this.BlocksLoading = true;
                this.$ajax({
                    method: "get",
                    url:
                        "requestType=getBlocks&firstIndex=0&lastIndex=5&includeTransactions=true"
                }).then(response => {
                    this.BlocksLoading = false;
                    if (
                        this.BlocksData.length != 0 &&
                        this.BlocksData[0].height != response.blocks[0].height
                    ) {
                        response.blocks[0] = this.$g.wallet.blocks(
                            response.blocks[0],
                            this.$store.state.apiText
                        );
                        this.BlocksData.unshift(response.blocks[0]);
                        this.Transactions(this.BlocksData[0]);
                        this.BlocksData.pop();
                    }

                    if (this.BlocksData.length == 0) {
                        this.BlocksData = response.blocks;
                        this.BlocksData.forEach(item => {
                            item = this.$g.wallet.blocks(item, this.$store.state.apiText);
                            this.Transactions(item);
                        });
                        this.BlocksData = response.blocks;
                    }
                });
            },
            init() {
                if (this.$store.state.apiText == "Rya" || this.$store.state.apiText == "Nxt"|| this.$store.state.apiText == "Aie"|| this.$store.state.apiText == "Actn") {
                    this.coinShow = false;
                    return;
                }
                this.coinShow = true;

                this.$ajax({
                    method: "get",
                    url: this.$store.state.walletnxt + "block/accountCount"
                }).then(response => {
                    this.accountCount = response[0].COUNT;
                });
                this.$ajax({
                    method: "get",
                    url: this.$store.state.walletnxt + "block/assetCount"
                }).then(response => {
                    this.assetCount = response[0].COUNT;
                });
                this.$ajax({
                    method: "get",
                    url: this.$store.state.walletnxt + "block/currencyCount"
                }).then(response => {
                    this.currencyCount = response[0].COUNT;
                });
                this.$ajax({
                    method: "get",
                    url: this.$store.state.walletnxt + "block/aliasCount"
                }).then(response => {
                    this.aliasCount = response[0].COUNT;
                });
            }
        },
        beforeDestroy: function () {
            window.clearInterval(load);
            window.clearInterval(loadline);
            window.clearInterval(deadline);
        },
        created: function () {
            this.$notify({
                title: 'Hebe Wallet',
                position: 'top-left',
                duration: 0,
                dangerouslyUseHTMLString: true,
                message: '<strong>' + this.$t('l.hebewallet') + '</strong><br><a target="_blank" href="https://www.hebe.cc" style="margin-top: 10px;display: block;text-align: center;padding: 12px 20px;font-size: 14px; border-radius: 4px;" class="el-button--primary">Go To</a>'
            });
            this.init();
            load = setInterval(() => {
                if (this.$store.state.epochBeginning != "") {
                    this.Generators();
                    this.Blocks();
                    loadline = setInterval(() => {
                        this.Blocks();
                        this.Generators();
                    }, 10000);
                    window.clearInterval(load);
                }
            }, 2000);
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    .tool_warp {
        padding: 20px;

        div {
            color: #fff;
        }

        .txt {
            text-align: right;
            font-size: 18px;
        }
    }

    .bg-purple {
        background: #58b3f9;
    }

    .grid-content {
        cursor: pointer;
        margin-top: 10px;
        border-radius: 4px;
        min-height: 36px;
    }
</style>



// WEBPACK FOOTER //
// src/components/index.vue